import React, { useState } from "react";
import { examDuration } from "../constant/Constants";

const AppAccordionPage = () => {
  const [active, setActive] = useState(1);
  const handleActive = (index) => {
    setActive((prev) => (prev === index ? 0 : index));
  };

  const faqDataFull = [
    {
      id: "One",
      ariaExpanded: "true",
      title: "What makes Practido the best app for preparing olympiad tests online?",
      content: "Practido stands out because it's the <u>best app for preparing olympiad tests online</u>, giving exam-level practice for SOF, SilverZone, Crest, and Hummingbird Olympiads with an engaging, gamified learning experience.",
    },
    {
      id: "Two",
      ariaExpanded: "false",
      title: "How can my child practice olympiad tests for Classes 1 to 10 using Practido?",
      content:
        "Practido offers class-specific content. Moreover, students can easily follow <u>how to practice olympiad tests for Classes 1 to 10</u> using interactive quizzes, topic-wise tests, and instant performance breakdowns that simplify preparation for exams from the Science Olympiad Foundation and similar boards.",
    },
    {
      id: "Three",
      ariaExpanded: "false",
      title: "Does Practido include mock exams similar to real olympiad tests?",
      content:
        "Yes! The app includes realistic mock tests that mirror the exact style of SOF, SilverZone, Crest, and Hummingbird Olympiads. These <u>interactive olympiad tests with mock exams</u> help students build confidence, speed, and accuracy, exactly what they need to perform well in competitive assessments.",
    },
    {
      id: "Four",
      ariaExpanded: "false",
      title: "Can students practice Science Olympiad tests with sample questions?",
      content:
        "Absolutely. Practido provides high-quality <u>sample questions</u> aligned with the Science Olympiad Foundation patterns. Students get to solve <u>science olympiad tests with sample questions</u>, making it easier to revise difficult topics, understand exam difficulty, and track strengths and weaknesses.",
    },
    {
      id: "Five",
      ariaExpanded: "false",
      title: "Is Practido helpful for beginners preparing for Maths Olympiad tests?",
      content:
        `Yes, the app is perfect for young learners and beginners. Each chapter includes simple explanations, step-by-step practice, and exam-level mock tests. If you're looking for <u>maths olympiad tests for beginners</u>, Practido gives exactly the structure needed to build confidence from the basics.
        `,
    },
    
  ];
  return (
    <div className="accordion" id="accordiondata">
      {faqDataFull?.map(({ id, ariaExpanded, title, content }, index) => (
        <div
          className={`card ${active === index + 1 ? "active" : ""}`}
          key={id}
        >
          <div className="card-header" id={`heading${id}`}>
            <button
              className={`btn-link btn-block text-left ${
                ariaExpanded !== "true" ? "collapsed" : ""
              }`}
              type="button"
              data-toggle="collapse"
              data-target={`#collapse${id}`}
              aria-expanded={ariaExpanded}
              aria-controls={`collapse${id}`}
              onClick={() => handleActive(index + 1)}
            >
              {title}
            </button>
          </div>
          <div
            id={`collapse${id}`}
            className={`collapse ${ariaExpanded === "true" ? "show" : ""}`}
            aria-labelledby={`heading${id}`}
            data-parent="#accordiondata"
          >
            <div
              className="card-body"
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppAccordionPage;
